import { utilisateursResolver } from './pages/utilisateurs/utilisateurs.resolver';
import { utilisateurDetailResolver } from './pages/utilisateur-detail/utilisateur-detail.resolver';
import { Route } from '@angular/router';
import { roleGuard } from '@/core/guards/role.guard';
import { PARAMS_ROLES } from '@/core/constants/access-roles';

export const parametresRoutes: Route = {
  path: 'parametres',
  // canActivateChild: [roleGuard([...PARAMS_ROLES])],
  children: [
    {
      path: 'utilisateurs',
      resolve: { utilisateurs: utilisateursResolver },
      loadComponent: () =>
        import('./pages/utilisateurs/utilisateurs.component').then((m) => m.UtilisateursComponent),
      canActivate: [roleGuard([...PARAMS_ROLES])],
    },
    {
      path: 'utilisateurs/:id',
      resolve: { data: utilisateurDetailResolver },
      loadComponent: () =>
        import('./pages/utilisateur-detail/utilisateur-detail.component').then(
          (m) => m.UtilisateurDetailComponent,
        ),
    },
    {
      path: 'configuration',
      loadComponent: () =>
        import('./pages/configuration/configuration.component').then(
          (m) => m.ConfigurationComponent,
        ),
      canActivate: [roleGuard([...PARAMS_ROLES])],
    },
    {
      path: 'configuration/itineraire/:ref',
      loadComponent: () =>
        import('./pages/configuration/config-credit/itineraire/itineraire.component').then(
          (m) => m.ItineraireComponent,
        ),
      canActivate: [roleGuard([...PARAMS_ROLES])],
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'utilisateurs',
    },
  ],
};
